var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleProcessing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6148 11.3059C14.4042 11.3059 14.2331 11.4769 14.2331 11.6871V17.2861H1.76415V1.7629H14.2331V4.22303C14.2331 4.43481 14.4048 4.60533 14.6148 4.60533C14.8249 4.60533 14.996 4.43431 14.996 4.22303V1.3812C14.996 1.17053 14.825 1 14.6148 1H1.3812C1.17053 1 1 1.17102 1 1.3812V17.6672C1 17.8778 1.17102 18.0495 1.3812 18.0495H14.6148C14.8255 18.0495 14.996 17.8773 14.996 17.6672V11.6876C14.996 11.477 14.8255 11.3059 14.6148 11.3059V11.3059Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5235 6.6436L15.9643 5.08383C15.8208 4.94081 15.5671 4.94081 15.4247 5.08383L9.73331 10.7746C9.68543 10.823 9.6513 10.883 9.63375 10.9484L9.08645 13.0549C9.05232 13.1857 9.09087 13.3255 9.1865 13.4212C9.25906 13.4933 9.35641 13.5328 9.45598 13.5328C9.48839 13.5328 9.52031 13.5284 9.55223 13.5202L11.6587 12.9735C11.7247 12.9564 11.7846 12.9218 11.8325 12.8734L17.5236 7.18263C17.6726 7.0347 17.6726 6.79273 17.5236 6.6437L17.5235 6.6436ZM11.3664 12.2608L9.98917 12.6183L10.3467 11.2411L14.4415 7.1463L15.4612 8.1665L11.3664 12.2608ZM16.0005 7.62669L14.9808 6.60699L15.6942 5.89359L16.7139 6.91329L16.0005 7.62669Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9001 3.54297H4.09604C3.88537 3.54297 3.71484 3.71398 3.71484 3.92527C3.71484 4.13593 3.88586 4.30646 4.09604 4.30646H11.9001C12.1107 4.30646 12.2818 4.13545 12.2818 3.92527C12.2823 3.71398 12.1106 3.54297 11.9001 3.54297Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2821 6.72495C12.2821 6.51428 12.1105 6.34375 11.9004 6.34375H4.09604C3.88537 6.34375 3.71484 6.51477 3.71484 6.72495C3.71484 6.935 3.88586 7.10614 4.09604 7.10614H11.9001C12.1106 7.10664 12.2822 6.93562 12.2822 6.72495H12.2821Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29521 9.14258H4.09604C3.88537 9.14258 3.71484 9.31359 3.71484 9.52488C3.71484 9.73554 3.88586 9.90607 4.09604 9.90607H8.29521C8.50588 9.90607 8.67641 9.73506 8.67641 9.52488C8.67629 9.3131 8.50527 9.14258 8.29521 9.14258Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09604 12.7069H7.44664C7.6578 12.7069 7.82834 12.5347 7.82834 12.3246C7.82834 12.1145 7.65733 11.9434 7.44664 11.9434L4.09604 11.9435C3.88537 11.9435 3.71484 12.1145 3.71484 12.3247C3.71484 12.5347 3.88537 12.7069 4.09604 12.7069V12.7069Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09604 15.5057H11.9001C12.1107 15.5057 12.2818 15.3347 12.2818 15.1245C12.2818 14.9144 12.1101 14.7422 11.9001 14.7422L4.09604 14.7423C3.88537 14.7423 3.71484 14.9144 3.71484 15.1246C3.71484 15.3347 3.88537 15.5057 4.09604 15.5057V15.5057Z",
    fill: "#714FFF",
    stroke: "#714FFF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleProcessing);
export default __webpack_public_path__ + "static/media/sample-processing.220abbf3bc5bd5dcea8f007e612b5d68.svg";
export { ForwardRef as ReactComponent };